'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotesController = function () {
  function NotesController(addPromiseService, authService, contactService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, NotesController);
    this.addPromiseService = addPromiseService;
    this.authService = authService;
    this.contactService = contactService;
  }

  (0, _createClass3.default)(NotesController, [{
    key: 'addNote',
    value: function addNote() {
      if (this.tempNote) {
        var newNote = {
          text: this.tempNote,
          date: 'Now',
          timeStamp: new Date()
        };

        this.notesCollection = [newNote].concat((0, _toConsumableArray3.default)(this.notesCollection));

        /*
        * There was a contact id passed in arguments to this NotesController
        * which means that this should be saved to the contact instantly
        */
        if (this.contactId) {
          this.contactService.addNote(this.authService.authData.currentLocation.key, this.contactId, this.tempNote);
        }

        this.tempNote = '';
      }
    }
  }, {
    key: 'addNoteWithPromise',
    value: function addNoteWithPromise() {
      if (this.tempNote) {
        this.addPromiseService.showAddPromise(this.addPromise.bind(this), true, this.tempNote, this.contact, true);
      }
    }
  }, {
    key: 'addPromise',
    value: function addPromise(promise) {
      var ctrl = this;

      var newNote = {
        text: this.tempNote,
        date: 'Now',
        timeStamp: new Date(),
        promise: promise
      };

      this.notesCollection = [newNote].concat((0, _toConsumableArray3.default)(this.notesCollection));

      this.tempNote = '';
    }
  }]);
  return NotesController;
}();

exports.default = NotesController;


// WEBPACK FOOTER //
// ./client/app/components/common/notes/notes.controller.js